interface Props {
  className: any;
}

export const Swapicon1 = ({ className }: Props): JSX.Element => {
  return (
    <svg
      className={`${className}`}
      fill="none"
      height="42"
      viewBox="0 0 42 42"
      width="42"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M36.375 17.5837H5.625M27.8333 3.91699V10.7503M14.1667 3.91699V10.7503M13.825 38.0837H28.175C31.0453 38.0837 32.4804 38.0837 33.5767 37.5251C34.541 37.0337 35.3251 36.2497 35.8164 35.2854C36.375 34.1891 36.375 32.7539 36.375 29.8837V15.5337C36.375 12.6634 36.375 11.2283 35.8164 10.132C35.3251 9.16763 34.541 8.3836 33.5767 7.89225C32.4804 7.33366 31.0453 7.33366 28.175 7.33366H13.825C10.9547 7.33366 9.5196 7.33366 8.4233 7.89225C7.45897 8.3836 6.67494 9.16763 6.18359 10.132C5.625 11.2283 5.625 12.6634 5.625 15.5337V29.8837C5.625 32.7539 5.625 34.1891 6.18359 35.2854C6.67494 36.2497 7.45897 37.0337 8.4233 37.5251C9.5196 38.0837 10.9547 38.0837 13.825 38.0837Z"
        stroke="#657D84"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  );
}; 